import React, {useEffect, useState} from "react";
import KitTypeForm from './kitTypeForm';
import { jsxActions as fetchEntitiesActions } from '../../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as createKitTypeFormActions} from '../../../../actions/Administration/MatSettingsPage/createKitTypeFormActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';

const getState = (state) => {
  return {
    formData: state.administration.getIn(['matSettingsPage', 'createKitTypeForm']),
    sLoggedInUser : state.login.get('loggedInUser'),
  }
}

const allActions = {
  actions: createKitTypeFormActions,
  fetchEntitiesActions: fetchEntitiesActions,
};


function KitTypeFormWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { formData, loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    let kitTypeId = props.match.params.kitTypeId;
    if (kitTypeId) {
      actions.actions.fetchFormItem(kitTypeId).then(data => {
        if (data) {
          setItem(data);
          setInitialized(true);
        }
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      actions.actions.clearFormData();
    }
  }, []);


  return  initialized && !loading  ?
    <KitTypeForm initialData={item}
                 sData={formData}
                 actions={{...actions.actions, ...actions.fetchEntitiesActions}}
                 {...props } />
    :
    <Overlay.Loading />
}

export default KitTypeFormWrapper;
